import { dateToUnixTime } from '../utils/DateHelper';
import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { Response } from '@angular/http';
import { DEFAULT_PAGE_SIZE } from './services-constants';

import * as moment from 'moment';

export const DAILY_RECURRENCE = 0;
export const ABSOLUTE_MONTHLY_RECURRENCE = 1;
export const RELATIVE_MONTHLY_RECURRENCE = 2;
export const RELATIVE_YEARLY_RECURRENCE = 3;
export const WEEKLY_RECURRENCE = 4;
export const ABSOLUTE_YEARLY_RECURRENCE = 5;

@Injectable()
export class AgendaService {

  constructor(private httpClient: HttpClient){

  }

  getActividad(consignaId: string, page: number = 0){
    return this.httpClient.get(`/api/actividad/consigna/${consignaId}/${DEFAULT_PAGE_SIZE}/${page}`)
      .map((response: Response) => {
        return response.json();
      });
  }

  getConsignas(fromDate: Date, toDate?: Date, syncOutlook?: boolean, isWeek?: boolean) {

    let from = fromDate ? dateToUnixTime(fromDate) : 0;
    let to = toDate ? dateToUnixTime(toDate) : 0;

    let type = from == 0 ? 'draft' : 'week';

    let request = {
      TimeRange: type,
      From: from,
      SyncOutlook: syncOutlook
    };

    if (toDate){
      type = isWeek ? type : 'range';
      request.TimeRange = type;
      request['To'] = to;
      request.SyncOutlook = syncOutlook;
    }

		return this.httpClient.post('/api/consigna/filter', request)
      .map((response: Response) => {
          return response.json();
      });
  }

  getConsigna(id: string){
    return this.httpClient.get(`/api/consigna/${id}`)
      .map((response: Response) => {
        return response.json();
      });
  }

  addConsigna(consignaTitle: string, fromDate: Date, toDate: Date,
    selectedMotores: any[], selectedColaboradores: any[], selectedCuentas: any[],
    selectedEtiquetas: any[], customNotification: boolean, horasVencimiento: number,
    sendEmailCopy: boolean, descripcion: string, recurrence){

    let from = fromDate ? dateToUnixTime(fromDate) : 0;
    let to = toDate ? dateToUnixTime(toDate) : 0;

    if(recurrence && (Object.keys(recurrence).length === 0)){
      recurrence = null;
    }

    let request = {
      Title: consignaTitle,
      StartDate: from,
      EndDate: to,
      Motores: selectedMotores,
      ConsignaResponsables: selectedColaboradores,
      Clientes: selectedCuentas,
      Etiquetas: selectedEtiquetas,
      CustomNotification: customNotification,
      SendEmailCopy: sendEmailCopy,
      HorasNotificacion: horasVencimiento,
      Descripcion: descripcion,
      Recurrence: recurrence
    };

    return this.httpClient.post('/api/consigna/', request)
      .map((response: Response) => {
        return response.json();
      })
  }

  editConsigna(id: string, consignaTitle: string, fromDate: Date, toDate: Date,
    selectedMotores: any[], selectedColaboradores: any[], selectedCuentas: any[],
    selectedEtiquetas: any[], customNotification: boolean, horasVencimiento: number, sendEmailCopy: boolean, descripcion: string){

    let from = fromDate ? dateToUnixTime(fromDate) : 0;
    let to = toDate ? dateToUnixTime(toDate) : 0;

    let request = {
      Id: id,
      Title: consignaTitle,
      StartDate: from,
      EndDate: to,
      Motores: selectedMotores,
      ConsignaResponsables: selectedColaboradores,
      Clientes: selectedCuentas,
      Etiquetas: selectedEtiquetas,
      CustomNotification: customNotification,
      SendEmailCopy: sendEmailCopy,
      HorasNotificacion: horasVencimiento,
      Descripcion: descripcion
    };

    return this.httpClient.put('/api/consigna/', request)
      .map((response: Response) => {
        return response.json();
      });
  }

  rateConsigna(id: string, rating: number){
    return this.httpClient.post(`/api/consigna/rate?id=${id}&rate=${rating}`, null)
      .map((response: Response) => {
        return response.json();
      })
  }

  reactivateConsigna(id: string){
    return this.httpClient.post(`/api/consigna/reactivar/${id}`, null)
      .map((response: Response) => {
        return response.json();
      });
  }

  deleteConsigna(id: string){
    return this.httpClient.delete(`/api/consigna/${id}`)
      .map((response: Response) => {
        return response.json();
      })
  }

  addConsignaComment(consignaId: string, comment: string){

    let userId = localStorage.getItem('userId');

    let request = {
      ConsignaId: consignaId,
      Comment: comment,
      FechaComment: dateToUnixTime(new Date()),
      Usuario: {
        UserId: userId
      }
    };

    return this.httpClient.post('/api/consigna/comment/', request)
      .map((response: Response) => {
          return response.json();
      });
  }

  editComment(commentId: string, comment: string){
    let request = {
      Id: commentId,
      Comment: comment
    };

    return this.httpClient.put('/api/consigna/comment/', request)
      .map((response: Response) => {
        return response.json();
      });
  }

  deleteComment(commentId: string){
    return this.httpClient.delete(`/api/consigna/comment/${commentId}`)
      .map((response: Response) => {
        return response.json();
      });
  }

  moveConsigna(id: string, firstDay: Date, hourOffset?: number) {
    return this.getConsigna(id).flatMap(data => {
      const consigna = data.ResponseData;
      const diff = moment(firstDay).diff(moment(consigna.StartDate * 1000).startOf('day'), 'days');
      let fromDate = moment(consigna.StartDate * 1000).add(diff, 'days');
      let toDate = moment(consigna.EndDate * 1000).add(diff, 'days');

      if (hourOffset) {
        const length = toDate.diff(fromDate, 'minutes');
        fromDate.hours(Math.floor(hourOffset/2));
        fromDate.minutes((hourOffset % 2) * 30);
        toDate = moment(fromDate).add(length, 'minutes');
      }

      // TODO: respetar customNotification y sendEmailCopy en lugar de poner false false, cuando la API me los traiga
      return this.editConsigna(
        id,
        consigna.Title,
        fromDate.toDate(),
        toDate.toDate(),
        consigna.ConsignaMotor,
        consigna.ConsignaResponsables,
        [consigna.Cliente],
        [],
        false,
        consigna.HorasNotificacion,
        false,
        consigna.Descripcion);
    });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/agenda-service.ts